export type Result<T> = { error: Error; data: null } | { error: null; data: T };

export const left = (r: Error) => ({ error: r, data: null });
export const right = <T>(r: T) => ({ error: null, data: r });
